import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

type LayoutProps = {
  className?: string
}

export const MobileOuterLayout = ({
  className,
  children,
}: PropsWithChildren<LayoutProps>) => {
  return (
    <div className={cn('mx-auto my-0 flex h-fit w-full grow', className)}>
      {children}
    </div>
  )
}

export const MobileInnerLayout = ({
  className,
  children,
}: PropsWithChildren<LayoutProps>) => {
  return (
    <div className={cn('m-0 w-full shrink-0 grow px-4 py-10', className)}>
      {children}
    </div>
  )
}

export const MobileLayout = ({
  className,
  children,
}: PropsWithChildren<LayoutProps>) => {
  return (
    <MobileOuterLayout>
      <MobileInnerLayout className={className}>{children}</MobileInnerLayout>
    </MobileOuterLayout>
  )
}
